









import { Component, Vue } from "vue-property-decorator";
import WpHeader from "./components/wp/WpHeader.vue";
import WpFooter from "./components/wp/WpFooter.vue";
import "iframe-resizer/js/iframeResizer.contentWindow";

@Component({
  components: {
    WpHeader,
    WpFooter
  }
})
export default class WPLayout extends Vue {
  beforeMounted() {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://use.typekit.net/esv7fns.css";
    document.head.appendChild(link);
  }
}
